import { Stack } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import NitrogenSmartFloatingButton from '/@/components/nitrogen-smart/buttons/floating-button';
import Spinner from '/@/components/spinner';
import { useFieldById } from '/@/hooks/fields';
import { useGetHistoricalWeather } from '/@/hooks/weather';
import { getNitrogenSmartEnabled } from '/@/store/session/selectors';
import type { CropMonitoring } from '/@/types/crop-monitoring';
import { getCropMonitoringData } from '/@/utils/crop-monitoring';
import CreateRecommendationModal from '/@/views/dashboard/rv/components/create-recommendation-modal';
import FieldMonitoringDetail from '../../../components/detail';

const FieldMonitoringDashboardCurrentCampaign = ({
    cropMonitoringId,
    fieldId,
    cropMonitoring,
    isCMLoading,
}: {
    cropMonitoringId?: number;
    fieldId?: number;
    cropMonitoring?: CropMonitoring;
    isCMLoading: boolean;
}) => {
    const [newRecommendationModalOpened, setNewRecommendationModalOpened] = useState(false);
    const nSmartEnabled = useSelector(getNitrogenSmartEnabled);

    const fieldQuery = useFieldById(
        { id: fieldId || cropMonitoring?.field || 0 },
        { enabled: Boolean(fieldId || cropMonitoring?.field) }
    );

    const weatherCropMonitoringId = cropMonitoring?.id ?? cropMonitoringId;
    const { data: historicalWeather, loading: loadingWeather } = useGetHistoricalWeather(
        weatherCropMonitoringId ?? 0,
        {},
        { startDays: 0, enabled: Boolean(weatherCropMonitoringId) }
    );

    let showNSmartButton = false;
    const cropData = getCropMonitoringData(cropMonitoring);
    if (cropMonitoring && nSmartEnabled) {
        if (
            cropData?.phenology === 'emergence' &&
            cropData?.vegetativeStage < 6 &&
            fieldQuery.data?.geometry.length > 1
        ) {
            showNSmartButton = true;
        }
    }

    return (
        <Stack direction='column' spacing={3}>
            {showNSmartButton && (
                <NitrogenSmartFloatingButton
                    cropMonitoringId={cropMonitoring?.id}
                    showNew={cropMonitoring?.nitrogenRecomendations.length === 0}
                    vegetativeStage={cropData?.vegetativeStage}
                    phenology={cropData?.phenology}
                    nitrogenRecommendations={cropMonitoring?.nitrogenRecomendations}
                />
            )}
            {isCMLoading || fieldQuery.isLoading ? (
                <Grid container justifyContent='center' alignItems='center' item xs={12} sx={{ height: '100%' }}>
                    <Spinner />
                </Grid>
            ) : (
                <FieldMonitoringDetail
                    fieldId={cropMonitoring?.field || fieldId}
                    cropMonitoring={cropMonitoring}
                    historicalWeather={historicalWeather}
                    loadingWeather={loadingWeather}
                />
            )}
            <CreateRecommendationModal
                open={newRecommendationModalOpened}
                setOpen={() => setNewRecommendationModalOpened(!newRecommendationModalOpened)}
                selectedField={fieldQuery.data || undefined}
                setSelectedField={(field) => {}}
                userNodeId={fieldQuery.data?.userNode}
                entrySource='field-monitoring'
            />
        </Stack>
    );
};

export default FieldMonitoringDashboardCurrentCampaign;
